// extracted by mini-css-extract-plugin
module.exports = {"errorMessage":"_94cb458","toggleLabel":"_d3bfa61","infoPrompt":"_dfb2f0a"};